import { Field } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { t } from "i18next";

import { getCountryList } from "../../../redux/features/conference-details/conferenceSlice";
import { properties } from "../../../constants/properties";
import { STRING_CONSTANT } from "../../../constants/constants";

const FormCountrySelectField = (props) => {
  const { label, fieldName, error, touched } = props;
  const { countryList } = useSelector((state) => state.conferenceDetails);
  const dispatcher = useDispatch();

  useEffect(() => {
    dispatcher(getCountryList());
  }, []);

  return (
    <div className="mb-3">
      <label htmlFor={fieldName} className="form-label">
        {label}<span className="text-danger">{STRING_CONSTANT.SPACE}*</span>
      </label>
      <Field
        as="select"
        className="form-select"
        id={fieldName}
        name={fieldName}
      >
        <option value="" disabled={true}>{t("select-country")}</option>
        {countryList?.items?.map((country) => (
          <option key={country?.id} value={country?.name}>
            {properties.languageId === "ar_SA"
              ? country?.title_i18n.ar_SA
              : country?.title_i18n.en_US}
          </option>
        ))}
      </Field>
      {error && touched ? (
        <div className="text-danger">{error}</div>
      ) : (
        STRING_CONSTANT.BLANK
      )}
    </div>
  );
};

export default FormCountrySelectField;
